import React from 'react';
export var Context = React.createContext();